<template>
  <div
    ref="chartDom"
    :id="id"
    :style="{ width: width, height: height }"
    class="echart-container"
  ></div>
</template>

<script>
import echarts from "echarts";

export default {
  props: {
    // 图表配置项（必传）
    option: {
      type: Object,
      required: true,
      default: () => ({}),
    },
    // 宽度（默认 100%）
    width: {
      type: String,
      default: "100%",
    },
    // 高度（默认 400px）
    height: {
      type: String,
      default: "400px",
    },
    // 是否自动响应窗口大小
    autoResize: {
      type: Boolean,
      default: true,
    },
    // 图表实例
    id: {
      type: String,
      default: () => `echart-${Date.now()}`,
    },
  },
  data() {
    return {
      chartInstance: null,
    };
  },
  mounted() {
    // 初始化图表（确保 DOM 已渲染）
    this.$nextTick(() => {
      this.initChart();
      if (this.autoResize) {
        window.addEventListener("resize", this.handleResize);
      }
    });
  },
  beforeDestroy() {
    // 清理实例和事件
    if (this.chartInstance) {
      this.chartInstance.dispose();
    }
    if (this.autoResize) {
      window.removeEventListener("resize", this.handleResize);
    }
  },
  methods: {
    initChart() {
      if (!this.$refs.chartDom || this.chartInstance) return;
      this.chartInstance = echarts.init(this.$refs.chartDom);
      this.chartInstance.setOption(this.option);
    },
    handleResize() {
      this.chartInstance && this.chartInstance.resize();
    },
  },
  watch: {
    // 监听配置项变化，自动更新
    option: {
      handler(newVal) {
        this.chartInstance && this.chartInstance.setOption(newVal);
      },
      deep: true,
    },
    // 监听宽高变化，调整大小
    width() {
      this.$nextTick(() => this.handleResize());
    },
    height() {
      this.$nextTick(() => this.handleResize());
    },
    // 监听 id 变化，重新初始化图表
    id() {
      console.log("idaaaaaaaaaaaaa", this.id);
      this.$nextTick(() => this.initChart());
    },
  },
};
</script>

<style scoped>
.echart-container {
  overflow: hidden;
}
</style>



// WEBPACK FOOTER //
// src/components/crossAnalysis/chartLine.vue